import { render, staticRenderFns } from "./category-faq.vue?vue&type=template&id=0082b99e&"
import script from "./category-faq.vue?vue&type=script&lang=js&"
export * from "./category-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports